var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"common-report qtime-activity-view"},[_c('div',[_c('div',[_c('qtime-report-header'),_c('finance-report-relation')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }